// extracted by mini-css-extract-plugin
export default {"numberFilterInputField":"OkbRtgs"};